<template>
  <div class="main">
    <tab title="分配记录" right-text="返回顶部" :fixed = true  class="tab"></tab>
    <div class="record_box">
      <div class="record_oli" v-for="item in list" v-bind:key="item.id">
        <div class="oli_title" v-if="item.cardNo">卡号：{{item.cardNo}}</div>
        <div class="oli_title" v-if="item.driverName">司机名称：{{item.driverName}}</div>
        <div class="oli_box"> 
          <div class="oli">姓名：{{item.createBy}}</div>
          <div class="oli">分配额度：{{item.assignAmount}}</div>
        </div>
        <div class="oli_box">
            <div class="oli">操作类型：{{item.assignType==1?'反分配':'分配'}}</div>
            <!-- <div class="oli">时间：{{item.createTime}}</div> -->
        </div>
        <div class="oli_box">
            <!-- <div class="oli">操作类型：{{item.assignType==1?'反分配':'分配'}}</div> -->
            <div class="oli">时间：{{item.createTime}}</div>
        </div>
        
      </div>
      <!-- <div class="record_oli">
        <div class="oli_title">卡号：700002</div>
        <div class="oli_box">
          <div class="oli">姓名：d</div>
          <div class="oli">分配额度：200.00</div>
        </div>
        <div class="oli_box">
            <div class="oli">操作类型：分配</div>
            <div class="oli">时间：2021-11-04 13:49:50</div>
        </div>
        
      </div> -->
    </div>
    <scroller :onBottom="loadmore"></scroller>
  </div>
</template>

<script>
import tab from "@/components/NavBar";
import scroller from "@/components/scroller";
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);

export default {
  name: "margin",
  data() {
    return {
      list: [],
      page: 1,
      pageSize: 7,
      flag:true
    };
  },
  components: {
    tab,
    scroller,
  },
  mounted() {
    var height = (document.body.clientHeight-46)/84
    this.pageSize = Math.ceil(height)
    this.getAssignList();
  },
  methods: {
    getAssignList() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      var data = {
        token: this.$storage.get("token"),
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$api.post("orgapp/getAssignList", data, (response) => {
        console.log(response.data);
        if (response.status >= 200 && response.status < 300) {
          Toast.clear();
          var data = response.data;
          if (data.msg == "success") {
            var list = data.list;
            list.forEach((element) => {
              element.assignAmount = (element.assignAmount / 100).toFixed(2);
            });
            if(list.length<this.pageSize){
                this.flag = false
            }
            if(this.page==1){
                this.list = list;
            }else{
                this.list = this.list.concat(list);
            }
            
          }
        }else{
           Toast.clear();
           Toast.fail(response.status);
        }
      });
    },
    loadmore() {
      console.log("触底了");
      if(this.flag){
        this.page++
        this.getAssignList()
      }else{
          Toast('没有更多内容了~');
      }
      
    },
  },
};
</script>

<style scoped>
.main {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 10px;
}
.record_box {
  width: 93%;
  margin: auto;
}
.record_oli {
  margin-top: 10px;
  width: 100%;
  min-height: 97px;
  background-color: #fff;
  position: relative;
  color: #000;
  border-radius: 6px;

}
.oli_box {
    display: flex;
}
.oli {
  flex: 1;
  margin-left: 8px;
  line-height: 25px;
}
.oli_title {
  border-bottom: 1px solid #eee;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/distribution_record.vue